export type CategoryProps = {
    companyName: string,
    fund: string,
    security: string,
    tranche: string,
    industrySector: string,
    country: string,
    holdingStatus: string,
    isPublic: string
}

export type DataProps = {
    shares: number,
    cost: number,
    unrealizedValue: number,
    unrealizedGainLoss: number,
    realizedValue: number,
    realizedGainLoss: number,
    totalGainLoss: number,
    costPerQuantity: number
}

export type SoiBaseData = {
    portfolioCompanyId: string,
    currencyCode: string,
    categoryProps: CategoryProps,
    dataProps: DataProps
};

export type SoiGridRow = {
    id: string,
    portfolioCompanyId: string,
    categorySource: string,
    categoryName: string,
    parentCategoryPath: string,
    level: number,
    currencyCode: string,

    [key: string]: any, // rest of data fields are dynamically added
};

export type CategoryFieldDef = {
    name: string,
    headerName: string,
    visible: boolean,
    order: number
}

export type ValueFieldDef = CategoryFieldDef & {
    numberFormat: 'Integer-use_commas' | 'Currency.0' | 'Currency.2' | 'Decimal-use-comas.2'
}


export const LevelColors = ['#3944bc','#281e5d','#016064','#241571','#2c3e4c','#757c88','#48AAAD','#0892c2'];